import { CommonFlags as c, DefaultColumns, EntityColumn, EntityDefinition } from "@mcurros2/microm";
import { ACTGestionarTiendas } from "./ACTGestionarTiendas";

const columns = () =>
(
    {
        c_region_id: new EntityColumn<string>({
            name: 'c_region_id', type: 'char', length: 20, flags: c.PKAutonum, prompt: 'Region Id',
            description: 'Identificador único de la región. Este campo es autogenerado y no puede ser modificado manualmente.'
        }),
        vc_nombre_region: new EntityColumn<string>({
            name: 'vc_nombre_region', type: 'varchar', length: 255, flags: c.Edit, prompt: 'Nombre Región',
            description: 'Nombre descriptivo de la región.'
        }),
        ...DefaultColumns()
    }
)

const views = () =>
(
    {
        regi_brwStandard: { name: 'regi_brwStandard', keyMappings: { c_region_id: 0 } }
    }
)

const lookups = () =>
(
    {

    }
)

const clientActions = () =>
(
    {
        ACTGestionarTiendas: ACTGestionarTiendas
    }
)

export class RegionesDef extends EntityDefinition {

    columns = columns();
    views = views();
    lookups = lookups();
    clientActions = clientActions();

    constructor() {
        super('Regiones');
    }
}